import { ComponentInstance } from "@uniformdev/canvas";

import { SideNav } from "@/libraries/design/patterns";
import { SideNavProps } from "@/libraries/design/patterns/side-nav/src/side-nav";

export interface UniformSideNavProps {
    component: ComponentInstance;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformNavItemData = (slots: any) => {
    return slots.map((childComponent: ComponentInstance) => {
        const childProps = childComponent.parameters ?? {};
        if (childComponent.type === "sideNavLink") {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const anchors = childProps["anchors"]?.value as any[];

            return {
                type: "link",
                text: childProps["text"]?.value as string,
                href: childProps["href"]?.value as string,
                anchors: anchors
                    ? anchors.map((anchor) => anchor.fields.text.value)
                    : null
            };
        }
        if (childComponent.type === "sideNavCollection") {
            return {
                type: "collection",
                collectionName: childProps["collectionName"]?.value as string,
                sideNavItems: transformNavItemData(
                    childComponent.slots?.["sideNavItems"]
                )
            };
        }
        return;
    });
};

const UniformSideNav = ({ component }: UniformSideNavProps) => {
    const slotItems = component.slots?.["sideNavItems"] ?? null;
    if (!slotItems) return;

    const sideNavItems = transformNavItemData(slotItems);
    const props: SideNavProps = {
        title: component.parameters?.["title"]?.value as string,
        sideNavItems: sideNavItems
    };

    return <SideNav {...props} />;
};

export default UniformSideNav;
